module.exports = __webpack_public_path__ + "static/media/sixFiftyCourt.1681f982.png";